// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__WEYu6","h2":"Card_h2__lGuN4","h3":"Card_h3__dgxxl","h4":"Card_h4__gGNSG"};